import { DlpOrderRequest } from 'apiConnector/secondary-market/dlpOrder/model';
import type { Custodian } from 'models/custodian';
import { getSecondaryMarketDlpProductIsinFromTab } from 'state/secondaryMarket/referential/dlpProduct/dlpProduct.selectors';
import { SecondaryMarketFormError } from 'state/secondaryMarket/shared/form/validationResults';
import type { AppState } from 'state/state.model';
import { createUtcDateTime } from 'utils/core/date';

import type { DlpOrderFormModel, SecondaryMarketDlpOrderTabContent } from './dlpOrderForm.model';

function getInputFormData(appState: AppState, tabId: string) {
  return appState.secondaryMarket.dlpOrder.form[tabId];
}

export function getInputFormQuantity(appState: AppState, tabId: string) {
  const form = getInputFormData(appState, tabId);
  return form?.quantity;
}
export function getInputFormLimit(appState: AppState, tabId: string) {
  const form = getInputFormData(appState, tabId);
  return form?.limit;
}
export function getInputFormLimitDate(appState: AppState, tabId: string) {
  const form = getInputFormData(appState, tabId);
  return form?.limitDate;
}
export function getInputFormLimitTime(appState: AppState, tabId: string) {
  const form = getInputFormData(appState, tabId);
  return form?.limitTime;
}
export function getInputFormTradeWay(appState: AppState, tabId: string) {
  const form = getInputFormData(appState, tabId);
  return form?.tradeWay;
}
export function getInputFormOrderType(appState: AppState, tabId: string) {
  const form = getInputFormData(appState, tabId);
  return form?.orderType;
}
export function getInputFormValidity(appState: AppState, tabId: string) {
  const form = getInputFormData(appState, tabId);
  return form?.validity;
}

export function getInputFormCustodianBdrId(appState: AppState, tabId: string) {
  return getInputFormCustodian(appState, tabId)?.id;
}

export function getInputFormCustodian(appState: AppState, tabId: string): Custodian | undefined {
  const form = getInputFormData(appState, tabId);
  return form?.custodian;
}

export type GetValidationErrorsFunc = (state: AppState, tabId: string) => SecondaryMarketFormError<DlpOrderFormModel>[];

export function getPlaceOrderRequest(state: AppState, tabId: string): DlpOrderRequest {
  const form = getInputFormData(state, tabId);
  const isin = getSecondaryMarketDlpProductIsinFromTab(state, tabId);
  const limitValidityDateTime = createUtcDateTime(form.limitDate, form.limitTime);
  return {
    isin,
    side: form.tradeWay,
    quantity: form.quantity,
    limitPrice: form.limit,
    orderType: form.orderType,
    timeInForce: form.validity,
    custodian: form.custodian,
    limitValidityDateTime,
  };
}
export function getDlpOrderTabContentToPersist(
  state: AppState,
  tabId: string,
): SecondaryMarketDlpOrderTabContent | undefined {
  const form = getInputFormData(state, tabId);
  if (form === undefined) {
    return undefined;
  }

  return {
    ...form,
    workspace: 'secondaryMarketQuotes',
    tabType: 'cpOrder',
  } as SecondaryMarketDlpOrderTabContent;
}
